import { useEventMessagesEnabled } from '@/features/events/hooks/useEventMessagesEnabled';
import { CUSTOMIZE_OPTIONS } from './customizeOptions';

export const useCustomizeOptions = () => {
  // The tab is a management surface, so it appears where text reminders work —
  // and, deliberately, where they *used* to: a lapsed workspace still has
  // messages listed here, and this is where they'd go to look at them. Business
  // workspaces never get the feature and a teased personal one has nothing to
  // manage yet, so neither sees the tab; that upsell lives on the event modal,
  // where there's something concrete to attach it to.
  const { isEnabled: messagesEnabled, isLapsed } = useEventMessagesEnabled();

  return CUSTOMIZE_OPTIONS.filter(
    (option) => option.id !== 'messages' || messagesEnabled || isLapsed
  );
};
